import api from './api'

/**
 * 敏感数据解密服务
 * 管理员通过此服务实时解密脱敏数据
 */
export const sensitiveDataService = {
  /**
   * 请求解密指定实体的敏感字段
   * @param {string} entityType - 实体类型: STUDENT_PROFILE, POTENTIAL_STUDENT, BLACKLIST, ENROLLMENT
   * @param {number} entityId - 实体ID
   * @param {string} field - 字段名: phone, idNumber, recommenderPhone, recommenderIdNumber, studentPhone
   * @returns {Promise<string>} 解密后的明文值
   */
  async decryptField(entityType, entityId, field) {
    const res = await api.post('/sensitive/decrypt', {
      entityType,
      entityId,
      field
    })
    // api.js 响应拦截器已将 axios response.data 解包
    // res = { success: true, message: "...", data: { value: "..." } }
    // 但也需要兼容未解包的情况
    if (res && res.data && res.data.value !== undefined) {
      return res.data.value
    }
    if (res && res.value !== undefined) {
      return res.value
    }
    throw new Error('解密响应格式异常: ' + JSON.stringify(res))
  }
}
